/**
 * Handle App's Page's Auto Navigation
 * Route controller will be handling app route on special occasion.
 * when user click back button or using deep link to open app, etc.
 * */

import { AppContext, ExAppContext } from '../Context';
import { Fragment, useContext, useEffect, useRef /*useState ---deprecated*/ } from 'react';
import { useLocation, useHistory } from 'react-router';
import { App } from '@capacitor/app';
import { isPlatform } from '@ionic/react';

//controllers
import DatabaseInterfaceController from './DatabaseInterfaceController';

//classes
import MemberUser from '../classes/memberUser';

interface Props {

}

const RouteController: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //router objs
    const location = useLocation();
    const history = useHistory();
    //refs
    const routeControlHistoryStacksRef =  useRef<string[]>(appContext.routeControlHistoryStacks);
    //controllers
    const database = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('RouteControllerTest: ' + JSON.stringify(appContext.routeControlHistoryStacks));
    // }, [appContext.routeControlHistoryStacks]);

    useEffect(() => {
        history.push('/Splash');

        //attach goback to previous page to general app
        appContext.SetRouteControlHistoryBackAction(() => GoBackToPreviousPage);
        //attach stay to previous page to general app
        // appContext.SetRouteControlHistoryStayAction(() => StaysAtCurrentPage); ---deprecated
    }, []);

    //watch for user changed, log in log out user
    useEffect(() => {
        if (Object.keys(appContext.user).length > 0) {
            if (location.pathname == '/Login') {
                history.push('/Home');
            }
        }
        else if(location.pathname != '/Splash' && location.pathname != '/') {
            history.push('/Login');
        }
    }, [appContext.user, location.pathname]);

    //watch for path changes
    useEffect(() => {
        //frame components control
        HeaderControl();
        NavBarControl();

        //path control
        PathControl();

        //app state change control
        appContext.SetAppStateChangeWatch(true);
        const appListenerActions = [] as any[];
        if (ProhibitionCheck([]) && AcceptionCheck(['/Login', '/Home', '/', '/Splash'])) {
            console.log('shouldExitAppOnBackButton');
            //on back button exit app
            appListenerActions.push(['backButton', () => { isPlatform('hybrid') ? App.exitApp() : null; }]);
        } else {
            //on back button window history go back
            appListenerActions.push(['backButton', null /** use default */]);
        }
        appListenerActions.push(['appStateChange', null]);
        appListenerActions.push(['appUrlOpen', null]);
        appContext.SetAppListenerActions([...appListenerActions]);

        //record location pathname
        if (appContext.routeControlHistoryStacks.length == 0 || (appContext.routeControlHistoryStacks[appContext.routeControlHistoryStacks.length - 1] != location.pathname)) {
            const _historyStacks: string[] = appContext.routeControlHistoryStacks;
            _historyStacks.push(location.pathname);
            appContext.SetRouteControlHistoryStacks([..._historyStacks]);
        }

        //check user pinnumber is set, if not auto-navigate to reset pin
        // if(Object.keys(appContext.user).length > 0 && appContext.user.pin_number.length == 0 && ProhibitionCheck(['/ResetPin'])) {
        //     appContext.SetPopupMessage('You are required to setup your 6-digits security pin number on first time login.');
        //     appContext.SetPopupButtons(['Setup Pin Now']);
        //     appContext.SetPopupActions([() => {history.push('/ResetPin');}]);
        // } ---deprecated

    }, [location.pathname]);

    //watch for routeControlHistoryStack update historyStackRef
    useEffect(() => {
        routeControlHistoryStacksRef.current = appContext.routeControlHistoryStacks;
    }, [appContext.routeControlHistoryStacks]);

    //exe functions
    const HeaderControl = () => {
        if (ProhibitionCheck(['/Login']) && AcceptionCheck([])) {
            appContext.SetHeaderShouldHide(false);
        } else {
            appContext.SetHeaderShouldHide(true);
        }
    }
    const NavBarControl = () => {
        if (ProhibitionCheck(['/Login', '/Splash', '/']) && AcceptionCheck([])) {
            appContext.SetNavBarShouldHide(false);
        } else {
            appContext.SetNavBarShouldHide(true);
        }
    }
    const PathControl = () => {
        // if(AcceptionCheck(['/ViewEvents', '/DiscoverEvents'])) {
        //     exAppContext.SetCurrentSelectedEvent({} as Event);
        // } ---deprecated of unused

        if(ProhibitionCheck(['/Splash', '/Login'])) {
            //reset piled up databaseActionModeQueue
            //exempted initializeFetch modes
            database.ResetQueue([
                'fetchCommitteeTypes', 'fetchEventCategories', 'fetchMemberFees', 'fetchInvoiceNotes', 'fetchDocumentCategories', 'fetchAssociatedBroadcasts', /*general*/
                'fetchMembershipRegistration', 'fetchMembership', 'fetchMembershipUsers', 'fetchMembershipContracts', 'fetchUserEventRegistrations', 'fetchUserUpcomingEvents', 'fetchViewableDocuments', /*members*/
                'fetchAllDocuments', 'fetchAllCommitteeMembers', 'fetchMeetingInvitations', 'fetchAcceptedUpcomingMeetings', 'fetchUnvotedCurrentAndVotedPolls', 'fetchHostedMeetings', 'fetchHostedMeetingInvitations', 'fetchHostedPolls', 'fetchOngoingEvents' /*committee*/
            ]);
        }
    }
    const ProhibitionCheck = (list: string[]) => {
        //prohibits if current page is match with list
        let passFailRes = true;
        if (list.length > 0)
            list.map((prohibited: string) => {
                if (location.pathname.toLowerCase() == prohibited.toLowerCase())
                    passFailRes = false;
            });
        return passFailRes;
    }
    const AcceptionCheck = (list: string[]) => {
        //accepts only if current page is match with list
        let passFailRes = true;
        if (list.length > 0) {
            passFailRes = false;
            list.map((accepted: string) => {
                if (location.pathname.toLowerCase() == accepted.toLowerCase())
                    passFailRes = true;
            });
        }
        return passFailRes;
    }

    //state functions
    const GoBackToPreviousPage = () => {
        const _historyStacks = routeControlHistoryStacksRef.current;
        _historyStacks.pop();
        appContext.SetRouteControlHistoryStacks([..._historyStacks]);
        if(_historyStacks.length > 0) {
            const lastPage = _historyStacks[_historyStacks.length - 1];
            //delay to prevent default
            //default backbutton will try to go back to current page if delay isn't set
            //after delay, backbutton will try to go back to any last stacked page, then this section of code will go exactly to what previousPage saved in routeControlHistoryStack
            history.push(lastPage);
        } else {
            if(isPlatform('hybrid')) {
                App.exitApp();
            }
        }
    }
    // const StaysAtCurrentPage = () => {
    //     const _historyStacks = routeControlHistoryStacksRef.current;
    //     appContext.SetRouteControlHistoryStacks([..._historyStacks]);
    //     if(_historyStacks.length > 0) {
    //         const currentPage = _historyStacks[_historyStacks.length - 1];
    //         //delay to prevent default
    //         //default backbutton will try to go back to previous page if delay isn't set
    //         //after delay, backbutton will try to go back to previous page, then this section of code will go exactly to what currentPage saved in routeControlHistoryStack
    //         history.push(currentPage);
    //     } else {
    //         if(isPlatform('hybrid')) {
    //             App.exitApp();
    //         }
    //     }
    // } ---deprecated, not needed any more, since setupConfig (ionic/react) prevent the default back button behavior

    return (
        <Fragment></Fragment>
    );
}
export default RouteController;